import { ReactNode } from 'react';
import { ConfirmationModal } from '@/components';
import { useModal } from '@/hooks';
import { getPropertyProgress, resetPropertyStep, selectPropertyProgressIsLoading } from '../../feature';
import { useAppDispatch, useAppState } from '@/store';
import { Button } from '@/ui';
import { StepType } from '@/models/step.model';
import { useTranslation } from 'react-i18next';
import { getEntityId } from '@/utils';

type TResetStepButtonProps = {
  propertyId: string;
  stepName: StepType;
  icon?: ReactNode;
  shouldResetStepData?: boolean;
};

const ResetStepButton = ({ propertyId, stepName, shouldResetStepData, icon }: TResetStepButtonProps) => {
  const { isOpened, openModal, closeModal } = useModal();
  const { t } = useTranslation('property');
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectPropertyProgressIsLoading);

  const handleConfirm = async () => {
    try {
      await dispatch(
        resetPropertyStep({ propertyId: getEntityId(propertyId), stepName, clearData: shouldResetStepData }),
      ).unwrap();
      await dispatch(getPropertyProgress({ propertyId: getEntityId(propertyId) })).unwrap();
      closeModal();
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <Button type="default" shape="round" onClick={openModal} icon={icon}>
        {t('button_reset_step')}
      </Button>
      <ConfirmationModal
        isOpened={isOpened}
        onCancel={closeModal}
        title={t('button_reset_step')}
        okButtonProps={{ type: 'primary', loading: isLoading }}
        cancelButtonProps={{ type: 'default' }}
        content={t('reset_confirmation_message')}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default ResetStepButton;
